import { ConnectionError, NotFoundError, ServiceUnavailableError } from '../../modules/app/errors';
import { WithdrawBadRequestError, WithdrawForbiddenError, WithdrawPendingError } from './errors';

const ADDITIONAL_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const withdrawUrl = `${api_config.bet_tracker_api}/wallet/withdrawals`;

// eslint-disable-next-line import/prefer-default-export
export const postWithdraw = (amount, pin) => {
  let status;
  let statusText;

  const switchStatus = json => {
    switch (status) {
      case 204: {
        return true;
      }
      case 400: {
        throw new WithdrawBadRequestError(statusText, status, json);
      }
      case 403: {
        throw new WithdrawForbiddenError(statusText, status, json);
      }
      case 404: {
        throw new NotFoundError(statusText, status, json);
      }
      case 409: {
        throw new WithdrawPendingError(statusText, status, json);
      }
      case 520: {
        throw new ServiceUnavailableError(statusText, status, json);
      }
      default: {
        throw new ConnectionError(statusText, status, json);
      }
    }
  };

  return fetch(withdrawUrl, {
    method: 'POST',
    headers: ADDITIONAL_HEADERS,
    body: JSON.stringify({ amount, pin }),
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      /* eslint-disable prefer-destructuring */
      status = response.status;
      statusText = response.statusText;
      /* eslint-enable prefer-destructuring */
      return response.json();
    })
    .then(switchStatus, switchStatus);
};

export const getWithdrawHistory = () => (
  fetch(withdrawUrl, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => response.json())
);

export const cancelWithdrawal = () => {
  let status;
  let statusText;

  const switchStatus = details => {
    switch (status) {
      case 204: {
        return true;
      }
      case 403: {
        throw new WithdrawForbiddenError(statusText, status, details);
      }
      case 404: {
        throw new NotFoundError(statusText, status, details);
      }
      case 520: {
        throw new ServiceUnavailableError(statusText, status, details);
      }
      default: {
        throw new ConnectionError(statusText, status, details);
      }
    }
  };

  return fetch(withdrawUrl, {
    method: 'DELETE',
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Accept: 'application/json'
    }
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      /* eslint-disable prefer-destructuring */
      status = response.status;
      statusText = response.statusText;
      /* eslint-enable prefer-destructuring */
      return response.json();
    })
    .then(switchStatus, switchStatus);
};
